import {GET_All_BED_STATUS, GET_All_BED_TYPES, GET_All_BED_TAGS, GET_DAY_CODES, GET_All_ATTENDANCE_STATUS} from '../actions/SettingAction'

const initialState ={
    allBedStatus: [],
    selectedBed: [],
    allBedTypes: [],
    allDayCodes: [],
    allAttendanceStatus:[]
}

const SettingReducer =  (state= initialState, action)=>{
    switch(action.type){
        case GET_All_BED_STATUS:
            return {...state, allBedStatus: action.data}
        case GET_All_BED_TYPES:
            return {...state, allBedTypes: action.data}
        case GET_All_BED_TAGS:
            return {...state, allBedTags: action.data}
        case GET_DAY_CODES:
                return {...state, allDayCodes: action.data}
        case GET_All_ATTENDANCE_STATUS:
            return {...state, allAttendanceStatus: action.data}
        default:
            return {...state}
    }
}

export default SettingReducer;